import * as React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
import styled from 'styled-components';
import { h400 } from '@helpcenter/styles/src/fonts';
import { isNewTextFieldEnabled } from 'feature-flags';
import * as qs from 'query-string';
import type { WrappedComponentProps } from 'react-intl-next';
import { FormattedMessage, injectIntl } from 'react-intl-next';
import { TextField } from 'view/common/fields/text-field';
import { ThemedButton } from 'view/common/themed-button';
import { ThemedLink } from 'view/common/themed-link';
import { token } from '@atlaskit/tokens';
import { FireScreenEventOnMount } from '@atlassian/help-center-common-util/analytics/fire-screen-event';
import { origin } from '@atlassian/help-center-common-util/location';
import messages from './messages';

interface LoginSingleSignOnProps {
    email: string;
    continueParam: string; //remove when removingfix-user-self-join-flow-from-portal-when-user-already-in-the-userbase_sztub
    redirectUrlLegacy: string; //remove when removingfix-user-self-join-flow-from-portal-when-user-already-in-the-userbase_sztub
    redirectUrl?: string; //remove the optional after cleaning up fix-user-self-join-flow-from-portal-when-user-already-in-the-userbase_sztub
}

export class LoginSingleSignOn extends React.Component<LoginSingleSignOnProps & WrappedComponentProps> {
    getSSOUrlLegacy = () => {
        const { email, continueParam, redirectUrlLegacy } = this.props;

        const searchString = qs.stringify({
            email,
            continue: continueParam,
            application: 'ondemand',
            tenant: origin(),
        });

        return `${redirectUrlLegacy}?${searchString}`;
    };

    getSSOUrl = () => {
        const { redirectUrl } = this.props;

        return redirectUrl || this.getSSOUrlLegacy();
    };

    getSSOFormContent = () => {
        const { intl, email } = this.props;

        return (
            <TextField
                id="user-email"
                shouldFitContainer
                label={intl.formatMessage(messages.emailLabel)}
                disabled
                defaultValue={email}
                updatedTextField={isNewTextFieldEnabled()}
            />
        );
    };

    getAtlassianAccountInfoSection = () => {
        const { intl } = this.props;

        const URI = 'https://support.atlassian.com/atlassian-account/docs/what-is-an-atlassian-account/';

        const supportLink = (
            <ThemedLink actionSubjectId="learnMoreAtlassianAccount" href={URI} target="_blank">
                {intl.formatMessage(messages.atlassianAccountInfoLink)}
            </ThemedLink>
        );

        return (
            <InfoSectionContainer>
                <InfoSectionTitle>
                    <FormattedMessage {...messages.atlassianAccountInfoTitle} />
                </InfoSectionTitle>
                <InfoSectionContent>
                    <FormattedMessage {...messages.atlassianAccountInfoContent} values={{ supportLink }} />
                </InfoSectionContent>
            </InfoSectionContainer>
        );
    };

    render() {
        return (
            <Container>
                <FireScreenEventOnMount />
                {this.getSSOFormContent()}
                <ButtonContainer>
                    <ThemedButton
                        id="login-button"
                        data-test-id="login-sso-button"
                        appearance="primary"
                        shouldFitContainer
                        actionSubjectId="submitLoginSSO"
                        href={this.getSSOUrl()}
                        // Disabling existing violations, should be fixed when revisited.
                        // eslint-disable-next-line jsx-a11y/no-autofocus
                        autoFocus
                    >
                        <FormattedMessage {...messages.continueWithAtlassianAccountButton} />
                    </ThemedButton>
                </ButtonContainer>
                {this.getAtlassianAccountInfoSection()}
            </Container>
        );
    }
}

export default injectIntl(LoginSingleSignOn);

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const Container = styled.div`
    text-align: left;
`;

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const ButtonContainer = styled.div`
    margin-top: ${token('space.300', '24px')};
`;

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const InfoSectionContainer = styled.div`
    margin-top: ${token('space.300', '24px')};
    border-top: 1px solid ${token('color.border', 'rgba(9, 30, 66, 0.14)')};
`;

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const InfoSectionTitle = styled.div`
    ${h400}
    margin-top: ${token('space.300', '24px')};
`;

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const InfoSectionContent = styled.div`
    margin-top: ${token('space.050', '4px')};
`;
